import React, { Component } from "react";
import Aux from "../../../../../../hoc/Auxilliary";

import { Radio, Checkbox } from "react-bootstrap";
class Answer extends Component {
  checkChanged() {
    // console.log("check changed");
  }
  render() {
    return (
      <Aux>
        {!this.props.isAssessmentSubmitted && this.props.questionTypeId === 1 && (
          <Radio
            className="customans"
            onClick={() => this.props.answerClicked(this.props.index)}
            name={"group" + this.props.questionId}
          >
            {this.props.text}
          </Radio>
        )}
        {!this.props.isAssessmentSubmitted && this.props.questionTypeId === 2 && (
          <Checkbox
            className="customans"
            onClick={() => this.props.answerClicked(this.props.index)}
            name={"group" + this.props.questionId}
          >
            {this.props.text}
          </Checkbox>
        )}
        {this.props.isAssessmentSubmitted && this.props.questionTypeId === 1 && (
          <Radio
            checked={this.props.isUserAnswer}
            onChange={() => this.checkChanged()}
            className={
              (this.props.isUserAnswer && this.props.isCorrectAnswer) ||
              this.props.isCorrectAnswer
                ? "correctanswer customans"
                : this.props.isUserAnswer && !this.props.isCorrectAnswer
                ? "wronganswer customans"
                : "customans"
            }
            onClick={() => this.props.answerClicked(this.props.index)}
            name={"group" + this.props.questionId}
          >
            {this.props.text}
          </Radio>
        )}
        {this.props.isAssessmentSubmitted && this.props.questionTypeId === 2 && (
          <Checkbox
            checked={this.props.isUserAnswer}
            onChange={() => this.checkChanged()}
            className={
              (this.props.isUserAnswer && this.props.isCorrectAnswer) ||
              this.props.isCorrectAnswer
                ? "correctanswer customans"
                : this.props.isUserAnswer && !this.props.isCorrectAnswer
                ? "wronganswer customans"
                : "customans"
            }
            onClick={() => this.props.answerClicked(this.props.index)}
            name={"group" + this.props.questionId}
          >
            {this.props.text}
          </Checkbox>
        )}
      </Aux>
    );
  }
}

export default Answer;



// WEBPACK FOOTER //
// ./src/containers/User/Learning/Assignment/Question/Answer/Answer.js